import React from 'react'
import MaintenanceCalender from '../../components/maintenancecalendarcomponents/MaintenanceCalendar'

function MaintenanceCalenderPage() {
    return (
        <>

            {/*Dynamic content goes here */}
            <MaintenanceCalender />

        </>
    )
}

export default MaintenanceCalenderPage;